const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
];

function parseLocalDate(value) {
    if (!value) return null;
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
    const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        return Number.isNaN(date.getTime()) ? null : date;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function addYears(date, years) {
    const result = new Date(date.getFullYear() + years, date.getMonth(), date.getDate());
    if (result.getMonth() !== date.getMonth()) {
        return new Date(date.getFullYear() + years, date.getMonth() + 1, 0);
    }
    return result;
}

function cleanRule(value) {
    return String(value || "")
        .trim()
        .replace(/\bcurent\b/gi, "current")
        .replace(/\bfisrt\b/gi, "first")
        .replace(/\blicense issuance year\b/gi, "Year of license issuance")
        .replace(/\s+/g, " ");
}

function ruleOffset(value) {
    const match = cleanRule(value).match(/\+\s*(\d+)/);
    return match ? Number(match[1]) : 0;
}

function parityForRule(value, personalDate, lastName) {
    const rule = cleanRule(value).toLowerCase();
    if (!rule) return null;

    if (rule.includes("last name a-l") || rule.includes("last name m-z")) {
        const initial = String(lastName || "").trim().charAt(0).toUpperCase();
        if (!initial) return null;
        return initial >= "A" && initial <= "L" ? "odd" : "even";
    }

    if (rule.includes("born even") || rule.includes("birth year even")) {
        if (!personalDate) return null;
        return personalDate.getFullYear() % 2 === 0 ? "even" : "odd";
    }

    if (rule.includes("odd year")) return "odd";
    if (rule.includes("even year")) return "even";
    return null;
}

function isParityRule(value) {
    const rule = cleanRule(value).toLowerCase();
    return rule.includes("odd year") || rule.includes("even year");
}

function yearMatchesParity(year, parity) {
    return parity === "even" ? year % 2 === 0 : year % 2 !== 0;
}

function firstYearWithParityAtOrAfter(year, parity) {
    return yearMatchesParity(year, parity) ? year : year + 1;
}

function monthDayParts(description, personalDate, boundary) {
    const raw = cleanRule(description);
    const lower = raw.toLowerCase();
    if (!raw) return null;

    const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return { month: Number(iso[2]) - 1, day: Number(iso[3]), yearAdjustment: 0 };

    const named = raw.match(new RegExp(`^(${MONTHS.join("|")})\\s+(\\d{1,2})$`, "i"));
    if (named) {
        return {
            month: MONTHS.findIndex((month) => month.toLowerCase() === named[1].toLowerCase()),
            day: Number(named[2]),
            yearAdjustment: 0,
        };
    }

    if (!personalDate) return null;
    const month = personalDate.getMonth();

    if (
        lower.includes("first day") &&
        (lower.includes("after birth") || lower.includes("following birth") || lower.includes("following the birth"))
    ) {
        return { month: (month + 1) % 12, day: 1, yearAdjustment: month === 11 ? 1 : 0 };
    }
    if (lower.includes("first day") && lower.includes("following the license")) {
        return { month: (month + 1) % 12, day: 1, yearAdjustment: month === 11 ? 1 : 0 };
    }
    if (lower.includes("last day preceding birth")) {
        return { month: (month + 11) % 12, lastDay: true, yearAdjustment: month === 0 ? -1 : 0 };
    }
    if (lower.includes("first day") && lower.includes("birth month")) {
        return { month, day: 1, yearAdjustment: 0 };
    }
    if (lower.includes("last day") && lower.includes("birth month")) {
        return { month, lastDay: true, yearAdjustment: 0 };
    }
    if (lower.includes("last day") && lower.includes("license issuance month")) {
        return { month, lastDay: true, yearAdjustment: 0 };
    }
    if (lower.includes("month of license issuance")) {
        return boundary === "start"
            ? { month, day: 1, yearAdjustment: 0 }
            : { month, lastDay: true, yearAdjustment: 0 };
    }
    if (lower === "birth month") {
        return boundary === "start"
            ? { month, day: 1, yearAdjustment: 0 }
            : { month, lastDay: true, yearAdjustment: 0 };
    }
    if (
        lower.includes("birthday") ||
        lower.includes("birthdate") ||
        lower.includes("date of license") ||
        lower.includes("license issue date") ||
        lower.includes("date of license issuance") ||
        lower.includes("based on issue date")
    ) {
        return { month, day: personalDate.getDate(), yearAdjustment: 0 };
    }
    return null;
}

function dateForBoundary(description, year, personalDate, boundary) {
    const parts = monthDayParts(description, personalDate, boundary);
    if (!parts || !Number.isInteger(year)) return null;
    const resolvedYear = year + (parts.yearAdjustment || 0);
    const day = parts.lastDay
        ? new Date(resolvedYear, parts.month + 1, 0).getDate()
        : parts.day;
    const date = new Date(resolvedYear, parts.month, day);
    return Number.isNaN(date.getTime()) ? null : date;
}

function startYearCandidates(ruleValue, referenceDate, personalDate, lastName) {
    const rule = cleanRule(ruleValue).toLowerCase();
    const referenceYear = referenceDate.getFullYear();
    if (/^\d{4}$/.test(rule)) return [Number(rule)];
    if (rule.includes("year of license issuance")) {
        return personalDate ? [personalDate.getFullYear() + ruleOffset(ruleValue)] : [];
    }
    if (isParityRule(ruleValue)) {
        const parity = parityForRule(ruleValue, personalDate, lastName);
        if (!parity) return [];
        const anchorYear = yearMatchesParity(referenceYear, parity)
            ? referenceYear
            : referenceYear - 1;
        return [anchorYear + ruleOffset(ruleValue)];
    }
    if (rule.includes("current year")) return [referenceYear + ruleOffset(ruleValue)];
    return [];
}

function endYearForRule(ruleValue, startYear, personalDate, lastName, cycleYears) {
    const rule = cleanRule(ruleValue).toLowerCase();
    const offset = ruleOffset(ruleValue);
    if (/^\d{4}$/.test(rule)) return Number(rule);
    if (rule.includes("year of license issuance")) {
        return personalDate ? personalDate.getFullYear() + offset : null;
    }
    if (isParityRule(ruleValue)) {
        const parity = parityForRule(ruleValue, personalDate, lastName);
        if (!parity) return null;
        return firstYearWithParityAtOrAfter(startYear, parity) + offset;
    }
    if (rule.includes("current year")) return startYear + offset;
    if (!rule) return startYear + (cycleYears || 0);
    return null;
}

function chooseCandidate(candidates, referenceDate, preferContaining) {
    if (!candidates.length) return null;
    if (preferContaining) {
        const containing = candidates.find(({ start, end }) => start <= referenceDate && referenceDate <= end);
        if (containing) return containing;
        const upcoming = candidates
            .filter(({ start }) => start > referenceDate)
            .sort((a, b) => a.start - b.start)[0];
        if (upcoming) return upcoming;
        return candidates.sort((a, b) => b.end - a.end)[0];
    }
    return candidates[0];
}

function rollCycleFromAnchor(start, end, cycleYears, referenceDate, endOfMonth = false) {
    if (!start || !end || !cycleYears) return null;
    let cycleStart = new Date(start);
    let cycleEnd = new Date(end);
    const shiftEnd = (date, years) => endOfMonth
        ? new Date(date.getFullYear() + years, date.getMonth() + 1, 0)
        : addYears(date, years);
    for (let i = 0; i < 100 && referenceDate > cycleEnd; i += 1) {
        cycleStart = addYears(cycleStart, cycleYears);
        cycleEnd = shiftEnd(cycleEnd, cycleYears);
    }
    for (let i = 0; i < 100 && referenceDate < cycleStart; i += 1) {
        cycleStart = addYears(cycleStart, -cycleYears);
        cycleEnd = shiftEnd(cycleEnd, -cycleYears);
    }
    return { start: cycleStart, end: cycleEnd };
}

export function getCycleYears(cycle) {
    if (!cycle) return null;
    const explicit = Number(cycle.cycle_length_years);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    const offset = ruleOffset(cycle.end_year);
    return offset || null;
}

export function isLicenseBased(cycle) {
    if (!cycle) return false;
    const start = cleanRule(cycle.start_day_month).toLowerCase();
    return (start.includes("license") || start.includes("issue")) && !start.includes("birth");
}

export function isLicenseYearAnchored(cycle) {
    return cleanRule(cycle?.start_year).toLowerCase().includes("year of license issuance");
}

export function hasGroups(cycle) {
    return Boolean(cycle?.groups?.length);
}

export function needsPersonalDate(cycle) {
    if (!cycle) return false;
    if (cycle.renewal_date_anchored) return false;
    const start = cleanRule(cycle.start_day_month).toLowerCase();
    // Column J can require the issue date even when column I is a fixed day/month.
    return isLicenseYearAnchored(cycle)
        || start.includes("license") || start.includes("birth") || start.includes("issue date");
}

export function requiresLicenseYear(cycle) {
    return Boolean(cycle?.requires_license_year);
}

export function usesProfileBirthDate(cycle) {
    if (!cycle || cycle.birthday_anchored) return false;
    return cleanRule(cycle.start_day_month).toLowerCase().includes("birth");
}

export function getCycleDateInputValue(cycle, savedDate, profileBirthDate) {
    if (savedDate) return String(savedDate).slice(0, 10);
    if (usesProfileBirthDate(cycle) && profileBirthDate) {
        return String(profileBirthDate).slice(0, 10);
    }
    return "";
}

export function getPersonalDateLabel(cycle) {
    if (!cycle) return "Enter Date";
    if (usesProfileBirthDate(cycle)) {
        return requiresLicenseYear(cycle)
            ? "Enter Your Birth Date and License Issue Year"
            : "Enter Your Birth Date";
    }
    return "Enter Your License Issue Date";
}

export function getPersonalDateFieldLabel(cycle) {
    if (!cycle) return "Date";
    return usesProfileBirthDate(cycle) ? "Date of Birth" : "License Issue Date";
}

export function getPersonalDateDescription(stateName, cycle) {
    if (!cycle) return "";
    if (cycle.custom_prompt) return cycle.custom_prompt;
    if (usesProfileBirthDate(cycle)) {
        if (requiresLicenseYear(cycle)) {
            return `${stateName || "This state"} calculates your CME cycle based on your birth month and the year your license was issued. Please enter both so we can compute your cycle dates.`;
        }
        return `${stateName || "This state"} calculates your CME cycle based on your birth month. Please enter your date of birth so we can compute your cycle dates.`;
    }
    return `${stateName || "This state"} calculates your CME cycle based on when your license was issued. Please enter your license issue date so we can compute your cycle dates.`;
}

function resolveGroupCycle(cycle, groupLabel, referenceDate) {
    const group = cycle.groups?.find((item) => item.label === groupLabel);
    if (!group) return null;
    const start = parseLocalDate(group.start);
    const end = parseLocalDate(group.end);
    if (!start || !end) return null;
    const cycleYears = getCycleYears(cycle) || Math.max(1, end.getFullYear() - start.getFullYear());
    const resolved = rollCycleFromAnchor(start, end, cycleYears, referenceDate);
    return resolved ? { ...resolved, groupLabel } : null;
}

function resolveBirthdayAnchoredCycle(cycle, licenseDate, birthDate, referenceDate) {
    if (!licenseDate || !birthDate) return null;
    const cycleYears = getCycleYears(cycle) || 1;
    let start = new Date(licenseDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    if (start < licenseDate) start = addYears(start, 1);
    const end = addYears(start, cycleYears);
    return rollCycleFromAnchor(start, end, cycleYears, referenceDate);
}

function resolveLicenseYearAnchoredCycle(cycle, birthDate, licenseYear, referenceDate) {
    const cycleYears = getCycleYears(cycle) || 1;
    if (!birthDate || !Number.isInteger(Number(licenseYear))) return null;
    const start = dateForBoundary(
        cycle.start_day_month,
        Number(licenseYear),
        birthDate,
        "start"
    );
    if (!start) return null;
    const nextStart = addYears(start, cycleYears);
    const end = new Date(nextStart.getFullYear(), nextStart.getMonth(), 0);
    return rollCycleFromAnchor(start, end, cycleYears, referenceDate);
}

function resolveGenericCycle(cycle, personalDate, lastName, referenceDate) {
    const startDescription = cleanRule(cycle.start_day_month);
    const endDescription = cleanRule(cycle.end_day_month);
    const startYearRule = cleanRule(cycle.start_year);
    const endYearRule = cleanRule(cycle.end_year);
    const cycleYears = getCycleYears(cycle);

    if (!startDescription || startDescription.toLowerCase() === "nan") return null;
    if (startDescription.toLowerCase() === "no cme requirements") return { noRequirements: true };

    const candidates = startYearCandidates(startYearRule, referenceDate, personalDate, lastName);
    if (!candidates.length && personalDate && !startYearRule) {
        const start = dateForBoundary(startDescription, personalDate.getFullYear(), personalDate, "start");
        if (!start || !cycleYears) return null;
        const end = endDescription
            ? dateForBoundary(endDescription, personalDate.getFullYear() + cycleYears, personalDate, "end")
            : addYears(start, cycleYears);
        return rollCycleFromAnchor(start, end, cycleYears, referenceDate);
    }

    const resolved = [];
    for (const startYear of candidates) {
        const endYear = endYearForRule(endYearRule, startYear, personalDate, lastName, cycleYears);
        const start = dateForBoundary(startDescription, startYear, personalDate, "start");
        const end = endDescription
            ? dateForBoundary(endDescription, endYear, personalDate, "end")
            : start && cycleYears
                ? addYears(start, cycleYears)
                : null;
        if (!start || !end) continue;
        if (end <= start) {
            const adjustedEnd = addYears(end, cycleYears || 1);
            resolved.push({ start, end: adjustedEnd });
        } else {
            resolved.push({ start, end });
        }
    }
    const chosen = chooseCandidate(resolved, referenceDate, false);
    if (
        chosen &&
        cycleYears &&
        (isLicenseYearAnchored(cycle) || /^\d{4}$/.test(startYearRule))
    ) {
        // A newly issued license can precede its first CME cycle by the
        // remainder of the issuance month. During that gap, show the first
        // cycle rather than manufacturing a cycle from before issuance.
        const rolloverReference = isLicenseYearAnchored(cycle)
            && personalDate
            && personalDate <= referenceDate
            && referenceDate < chosen.start
            ? chosen.start
            : referenceDate;
        return rollCycleFromAnchor(
            chosen.start, chosen.end, cycleYears, rolloverReference,
            endDescription.toLowerCase().includes("last day")
        );
    }
    return chosen;
}

export function resolveCycle(cycle, options = {}) {
    if (!cycle) return null;
    const referenceDate = parseLocalDate(options.referenceDate) || new Date();
    const personalDate = parseLocalDate(options.personalDateStr);
    const birthDate = parseLocalDate(options.birthDate);

    if (cycle.renewal_date_anchored) {
        // Birth month alone cannot establish which of the two renewal years
        // applies. Use the user's saved license expiration instead of guessing.
        const end = parseLocalDate(options.expirationDate);
        if (!end) return null;
        const years = getCycleYears(cycle);
        const start = addYears(end, -years);
        return rollCycleFromAnchor(start, end, years, referenceDate, true);
    }
    if (hasGroups(cycle) && options.groupLabel) {
        return resolveGroupCycle(cycle, options.groupLabel, referenceDate);
    }
    if (cycle.birthday_anchored) {
        return resolveBirthdayAnchoredCycle(cycle, personalDate, birthDate, referenceDate);
    }
    if (cycle.requires_license_year) {
        return resolveLicenseYearAnchoredCycle(cycle, personalDate, options.licenseYear, referenceDate);
    }
    return resolveGenericCycle(cycle, personalDate, options.lastName, referenceDate);
}

export function buildCycleText(cycle, personalDateStr, groupLabel, licenseYear, birthDate, options = {}) {
    if (!cycle) return "";
    if (needsPersonalDate(cycle) && !personalDateStr) return "";
    if (cycle.requires_license_year && !licenseYear) return "";

    const resolved = resolveCycle(cycle, {
        personalDateStr,
        groupLabel,
        licenseYear,
        birthDate,
        lastName: options.lastName,
        referenceDate: options.referenceDate,
        expirationDate: options.expirationDate,
    });
    if (resolved?.noRequirements) return "Cycle: No CME requirements";
    if (resolved?.start && resolved?.end) {
        const format = (date) => date.toLocaleDateString("en-US", {
            month: "long",
            day: options.monthYearOnly ? undefined : "numeric",
            year: "numeric",
        });
        const group = resolved.groupLabel ? ` (${resolved.groupLabel})` : "";
        return `Cycle: ${format(resolved.start)} through ${format(resolved.end)}${group}`;
    }
    return cycle.format ? `Cycle: ${cycle.format}` : "";
}

export function isCycleRolloverPreviewEnabled(search) {
    return new URLSearchParams(search || "").get("dev") === "true";
}

export function getCycleReferenceDateOverride(search, now = new Date(), enabled = isCycleRolloverPreviewEnabled(search)) {
    if (!enabled) return null;
    const params = new URLSearchParams(search || "");
    const dateValue = params.get("cycleDate");
    if (dateValue !== null) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) return null;
        const explicitDate = parseLocalDate(dateValue);
        const [year, month, day] = dateValue.split("-").map(Number);
        if (
            explicitDate?.getFullYear() === year &&
            explicitDate.getMonth() === month - 1 &&
            explicitDate.getDate() === day
        ) return explicitDate;
        return null;
    }

    const year = Number(params.get("cycleYear"));
    if (!Number.isInteger(year) || year < 2000 || year > 2100) return null;
    const maxDay = new Date(year, now.getMonth() + 1, 0).getDate();
    return new Date(year, now.getMonth(), Math.min(now.getDate(), maxDay));
}
